import { configureStore } from "@reduxjs/toolkit";
import CTDBProductListSlice from "./slices/CTDBProductListSlice";
import CTProductListSlice from "./slices/CTProductListSlice";
import UserProfileSlice from "./slices/UserProfileSlice";
import CTDBUserListSlice from "./slices/CTDBUserListSlice";
import UserFrontendProfileSlice from "./slices/UserPermissionsSlice";
import CTDBProductApproverListSlice from "./slices/CTDBProductApproverListSlice";
import CTDBProductContactListSlice from "./slices/CTDBProductContactListSlice";
import CTDBProductDetailsSlice from "./slices/CTDBProductDetailsSlice";
import CTDBPortfolioListSlice from "./slices/CTDBPortfolioListSlice";
import CTPortfolioListSlice from "./slices/CTPortfolioListSlice";
import CTDBProxyOwnerListSlice from "./slices/CTDBProxyOwnerListSlice";
import CTDBSkuListSlice from "./slices/CTDBSkuListSlice";
import CTDBCreateSkuSlice from "./slices/CTDBCreateSkuSlice";
import CTDBSkuConfigSlice from "./slices/CTDBSkuConfigSlice";
import CTDBSkuListAllSlice from "./slices/CTDBSkuListAllSlice";
import CTDBAssignProxySlice from "./slices/CTDBAssignProxySlice";
import CTDBUpdateProductSlice from "./slices/CTDBUpdateProductSlice";
import CTSkuInformationSlice from "./slices/CTSkuInformationSlice";
import CTSkuListSlice from "./slices/CTSkuListSlice";
import UserSessionMessageSlice from "./slices/UserSessionMessageSlice";
import CTProductDetailsSlice from "./slices/CTProductDetailsSlice";
import UserLogoutSlice from "./slices/UserLogoutSlice";
import CTDraftOrdersListSlice from "./slices/CTDraftOrdersListSlice";
import CheckoutSlice from "./slices/CheckoutSlice";
import WorkspaceListSlice from "./slices/WorkspaceListSlice";
import CTDBBMOApprovalListSlice from "./slices/CTDBBMOApprovalListSlice";
import OrderPipelineSlice from "./slices/OrderPipelineSlice";
import ConsumptionSlice from "./slices/ConsumptionSlice";
import CTDBDeleteSkuSlice from "./slices/CTDBSkuDeleteSlice";
import CTSKUApiKeyStatusSlice from "./slices/CTSKUApiKeyStatusSlice";
import EngagementNameSlice from "./slices/EngagementNameSlice";
import CTSectorIndustryListSlice from "./slices/CTSectorIndustryListSlice";
import ShareEstimateSlice from "./slices/ShareEstimateSlice";
import CTReportListSlice from "./slices/CTReportListSlice";
import CTReportDetailsSlice from "./slices/CTPBIEmbedDetailsSlice";
import CTDBBMOReviewSlice from "./slices/CTDBBMOFormApprovalSlice";
import CTDBBMOCostUpdateSlice from "./slices/CTDBBMOCostUpdateSlice";
import CTArtifactDetailsSlice from "./slices/CTArtifactDetailsSlice";
import OrderExtensionSlice from "./slices/OrderExtensionSlice";
import AppConfigurationSlice from "./slices/AppConfigurationSlice";
import OpportunityNameSlice from "./slices/OpportunityNameSlice";
import SyncOrderSlice from "./slices/SyncOrderSlice";
import AdminSupportSlice from "./slices/AdminSupportSlice";
import PreviousReturnSlice from "./slices/PreviousReturnSlice";
import EngagementDelegationSlice from "./slices/EngagementDelegationSlice";
import MaintenanceWindowSlice from "./slices/MaintenanceWindowSlice";
import ProvisionBillingPreviewSlice from "./slices/ProvisionBillingPreviewSlice";
import UsersSlice from "./slices/UsersSlice";

export const store = configureStore({
  reducer: {
    CTDBProductListSlice: CTDBProductListSlice,
    CTProductListSlice: CTProductListSlice,
    UserProfileSlice: UserProfileSlice,
    UserFrontendProfileSlice: UserFrontendProfileSlice,
    CTDBUserListSlice: CTDBUserListSlice,
    CTDBProductApproverListSlice: CTDBProductApproverListSlice,
    CTDBProductContactListSlice: CTDBProductContactListSlice,
    CTDBProductDetailsSlice: CTDBProductDetailsSlice,
    CTDBPortfolioListSlice: CTDBPortfolioListSlice,
    CTPortfolioListSlice: CTPortfolioListSlice,
    CTDBProxyOwnerListSlice: CTDBProxyOwnerListSlice,
    CTDBSkuListSlice: CTDBSkuListSlice,
    CTDBSkuListAllSlice: CTDBSkuListAllSlice,
    CTDBCreateSkuSlice: CTDBCreateSkuSlice,
    CTDBSkuConfigSlice: CTDBSkuConfigSlice,
    CTDBAssignProxySlice: CTDBAssignProxySlice,
    CTDBUpdateProductSlice: CTDBUpdateProductSlice,
    CTSkuInformationSlice: CTSkuInformationSlice,
    CTSkuListSlice: CTSkuListSlice,
    UserSessionMessageSlice: UserSessionMessageSlice,
    CTProductDetailsSlice: CTProductDetailsSlice,
    CTArtifactDetailsSlice: CTArtifactDetailsSlice,
    UserLogoutSlice: UserLogoutSlice,
    CTDraftOrdersListSlice: CTDraftOrdersListSlice,
    CheckoutSlice: CheckoutSlice,
    WorkspaceListSlice: WorkspaceListSlice,
    CTDBBMOApprovalListSlice: CTDBBMOApprovalListSlice,
    OrderPipelineSlice: OrderPipelineSlice,
    ConsumptionSlice: ConsumptionSlice,
    CTDBDeleteSkuSlice: CTDBDeleteSkuSlice,
    CTSKUApiKeyStatusSlice: CTSKUApiKeyStatusSlice,
    EngagementNameSlice: EngagementNameSlice,
    CTSectorIndustryListSlice: CTSectorIndustryListSlice,
    ShareEstimateSlice: ShareEstimateSlice,
    CTReportListSlice: CTReportListSlice,
    CTReportDetailsSlice: CTReportDetailsSlice,
    CTDBBMOReviewSlice: CTDBBMOReviewSlice,
    CTDBBMOCostUpdateSlice: CTDBBMOCostUpdateSlice,
    OrderExtensionSlice: OrderExtensionSlice,
    AppConfigurationSlice: AppConfigurationSlice,
    OpportunityNameSlice: OpportunityNameSlice,
    SyncOrderSlice: SyncOrderSlice,
    AdminSupportSlice: AdminSupportSlice,
    PreviousReturnSlice: PreviousReturnSlice,
    EngagementDelegationSlice: EngagementDelegationSlice,
    MaintenanceWindowSlice: MaintenanceWindowSlice,
    ProvisionBillingPreviewSlice: ProvisionBillingPreviewSlice,
    UsersSlice: UsersSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
